/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Ebr_Conn_Test_FailedInputs */

const cs_ebr_conn_test_failed = /** @type {(inputs: Ebr_Conn_Test_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Připojení selhalo: ${i?.error}`)
};

const en_ebr_conn_test_failed = /** @type {(inputs: Ebr_Conn_Test_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connection failed: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Connection failed: {error}" |
*
* @param {Ebr_Conn_Test_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conn_test_failed = /** @type {((inputs: Ebr_Conn_Test_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conn_Test_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conn_test_failed(inputs)
	return cs_ebr_conn_test_failed(inputs)
});